module.controller('sampleScheduleFiltersCtrl', [ '$compile', '$scope', '$rootScope', '$state', 'planSamplingService', 'alertService', 'dateUtilService', sampleScheduleFiltersCtrlFn ]);

function sampleScheduleFiltersCtrlFn($compile, $scope, $rootScope, $state, planSamplingService, alertService, dateUtil) {
	var vm = this;

	var vmparent = $scope.ctrl;

	vm.idSample = {};
	vm.datePicker = {};
	vm.datePicker2 = {};
	vm.client = {};
	vm.site = {};
	vm.area = {};
	vm.states = {};
	vm.tags = {};
	vm.planSampling = {};
	vm.planSiteSelected = 0;
	vm.availableTags = [ " " ];
	vm.clientCustomFilter = {
		active : true
	};

	/*
	 * refresca los query parameters de la url
	 */
	function realoadFilters() {
		var obj = {
			idClient : '',
			states : [],
			start : '',
			end : '',
			tag : [],
			site : '',
			area : '',
			idplan : '',
			sampleId : ''
		};
		// cliente
		if (vm.client.selected && vm.client.selected.length > 0) {
			obj.idClient = vm.client.selected[0].id;
		}

		// estados
		if (vm.states.selected && vm.states.selected.length > 0) {
			obj.states = [];
			for ( var i in vm.states.selected) {
				obj.states.push(vm.states.selected[i].enumName);

			}
		}

		// site
		if (vm.site.selected && vm.site.selected.length > 0) {
			obj.site = vm.site.selected[0].id;
		}

		// plan
		if (vm.planSampling.selected && vm.planSampling.selected.length > 0) {
			obj.idplan = vm.planSampling.selected[0].id;
		}

		// muestra
		if (vm.idSample.selected && vm.idSample.selected.length > 0) {
			obj.sampleId = vm.idSample.selected[0];
		}

		// area
		if (vm.area.selected && vm.area.selected.length > 0) {
			obj.area = vm.area.selected[0].id;
		}
		// tags
		if (vm.tags.selected && vm.tags.selected.length > 0) {
			obj.tag = [];
			for ( var i in vm.tags.selected) {
				obj.tag.push(vm.tags.selected[i]);
			}
		}
		// fecha de toma de muestra
		if (!isEmpty(vm.datePicker)) {
			if (vm.datePicker.startDate.isValid() && vm.datePicker.endDate.isValid()) {
				obj.start = dateUtil.date2String(vm.datePicker.startDate);
				obj.end = dateUtil.date2String(vm.datePicker.endDate.toDate());
			}
		}

		// paginacion
		if (vmparent.pagination.current) {
			obj.page = vmparent.pagination.current;
		}

		$state.go("home.sampleSchedule", obj, {
			reload : "home.sampleSchedule",
			notify : false,
		});
	}

	$scope.$on('$locationChangeSuccess', function(ev) {
		vm.search();
	});

	/*
	 * se ejecuta al cargar el controlador
	 */
	function init() {

		// inicia las fechas con una semana
		var now = moment();

		vm.datePicker.startDate = moment().startOf('week');
		vm.datePicker.endDate = moment().endOf('week');

		// muestra
		if ($state.params.sampleId){
			vm.idSample.selected = [$state.params.sampleId];
		}
		vm.isCollapsed = true;

		// cliente
		if ($state.params.idClient) {
			vm.client.id = $state.params.idClient;
			vm.isCollapsed = true;
		}

		// sitio
		if ($state.params.site) {
			vm.site.id = $state.params.site;
			vm.isCollapsed = true;
		}

		// area
		if ($state.params.area) {
			vm.area.id = $state.params.area;
			vm.isCollapsed = true;
		}

		// plan
		if ($state.params.idplan) {
			vm.planSampling.id = $state.params.idplan;
			vm.sitePlanSelectClick(1);
			vm.isCollapsed = true;
		}

		// estados
		if ($state.params.states) {
			if (angular.isArray($state.params.states)) {
				vm.stateIni = $state.params.states.map(function(s) {
					return getConstantById(SAMPLE_STATE, s);
				});
			} else {
				vm.stateIni = [];
				vm.stateIni.push(getConstantById(SAMPLE_STATE, $state.params.states));
			}
			vm.states.selected = vm.stateIni;
			vm.isCollapsed = true;
		}

		// tags
		if ($state.params.tag) {

			if (angular.isArray($state.params.tag)) {
				vm.availableTags = $state.params.tag;
			} else {
				// vm.stateIni = [];
				vm.availableTags = [];
				vm.availableTags.push($state.params.tag);

			}
			vm.tags.selected = vm.availableTags;
			vm.isCollapsed = true;
			// vm.tags.id = $state.params.tags
			// vm.isCollapsed = true;
		}

		// fecha de toma de muestra
		if ($state.params.start && $state.params.end) {
			vm.datePicker.startDate = dateUtil.formatMomentDate($state.params.start);
			vm.datePicker.endDate = dateUtil.formatMomentDate($state.params.end);
			vm.isCollapsed = true;
		}

		// paginacion
		if ($state.params.page) {
			vmparent.pagination.current = $state.params.page;
		}

		vm.search();
		$("#iconHelpState").qtip({
			content : {
				text : $("#helpState"),
				title : {
					text : "Código de colores de estados",
					button : true
				}
			},
			position : {
				viewport : $("#divMain"),
				my : 'left center',
				at : 'right center',
				container : $("#divMain"),
				adjust : {
					scroll : false,
					mouse : false
				}
			},
			show : {
				event : 'click',
				solo : true
			},
			hide : {
				event : 'unfocus'
			},
			style : {
				classes : 'qtip-bootstrap qtip-shadow qtip-rounded',
				width : "500px"
			}
		});

	}

	/**
	 * Realiza la búsqueda de muestras con los filtros definidos
	 */
	vm.search = function() {
		$scope.ctrl.loading = true;
		var filters = {};

		var page = vmparent.pagination.current;
		var ps = $rootScope.pageSize;
		// filter.offset = (page - 1) * ps;
		// filter.limit = ps;

		// muestra
		if (vm.idSample.selected && vm.idSample.selected.length > 0) {
			filters.idSample = vm.idSample.selected[0];
		}
		
		// fecha de programacion
		if (vm.datePicker.startDate.isValid() && vm.datePicker.endDate.isValid()) {
			vm.datePicker.startDate.startOf('day');
			vm.datePicker.endDate.endOf('day');
			filters.betweenscheduleDate = [ vm.datePicker.startDate.format($scope.ctrl.DTM_FORMAT), vm.datePicker.endDate.format($scope.ctrl.DTM_FORMAT) ];

			filters.scheduleDateisNull = "null";
		}

		// cliente
		if (vm.client.selected && vm.client.selected.length > 0) {
			filters.client = vm.client.selected[0].id;
		} else if (vm.client.id) {
			filters.client = vm.client.id;
		}

		// sitio
		if (vm.site.selected && vm.site.selected.length > 0) {
			filters.site = vm.site.selected[0].id;
		} else if (vm.site.id) {
			filters.site = vm.site.id;
		}

		// area
		if (vm.area.selected && vm.area.selected.length > 0) {
			filters.area = vm.area.selected[0].id;
		} else if (vm.area.id) {
			filters.area = vm.area.id;
		}
		// estados
		if (vm.states.selected && vm.states.selected.length > 0) {
			filters.state = [];
			for ( var i in vm.states.selected) {
				filters.state.push(vm.states.selected[i].enumName);
			}
		}
		// tags
		if (vm.tags.selected && vm.tags.selected.length > 0) {
			filters.tag = [];
			for ( var i in vm.tags.selected) {
				filters.tag.push(vm.tags.selected[i]);
			}
		}
		// plan de muestreo
		if (vm.planSampling.selected && vm.planSampling.selected.length > 0) {
			filters.planSampling = vm.planSampling.selected[0].id;
		} else if (vm.planSampling.id) {
			filters.planSampling = vm.planSampling.id;
		}

		// solo los planes de mmuestreo que no esten anulados
		filters['planSampling.state.notin'] = PLAN_SAMPLING_STATE.ANNUL.enumName;
		// solo las muestras que no esten anuladas
		filters['state.notin'] = PLAN_SAMPLING_STATE.ANNUL.enumName;
		// ordenado
		filters.orderby = [ "scheduleDate asc" ];

		planSamplingService.getAllSampleSimple(filters).then(function(response) {
			$scope.ctrl.loading = false;
			var result = response.getData();

			$scope.ctrl.samples = [];

			events = [];
			
			//organiza los valores, se ponene de primero los que estan pendientes por programar
			var filWaitingForSchedule = function(s){
				return s.state == SAMPLE_STATE.WAITING_FOR_SCHEDULE.enumName;
			};
			var filNoWaitingForSchedule = function(s){
				return s.state != SAMPLE_STATE.WAITING_FOR_SCHEDULE.enumName;
			};
			$scope.ctrl.samples = $scope.ctrl.samples.concat(result.filter(filWaitingForSchedule));
			$scope.ctrl.samples = $scope.ctrl.samples.concat(result.filter(filNoWaitingForSchedule));

			$scope.ctrl.samples.forEach(function(sample) {

				if (sample.scheduleDate) {
					var eventObject = $scope.ctrl.sample2Event(sample);
					events.push(eventObject);
					sample.className = eventObject.className;
					sample.scheduleDate = eventObject.start;
				} else {
					// obtiene el color de la constante
					sample.className = getConstantById(SAMPLE_STATE, sample.state).className;
				}
				// obtiene los tags
				pushTag(sample.tags);

			});

			$scope.ctrl.eventSource[0] = events;

			// modifica la vista al primer dia del filtro
			if (vm.datePicker.startDate.isValid())
				$scope.ctrl.goToDate(moment(vm.datePicker.startDate));

			// modifica la vista al primer dia del filtro si se hizo el filtro
			// por id de la muestra
			if ($scope.ctrl.samples.length == 1)
				if ($scope.ctrl.samples[0].scheduleDate)
					if ($scope.ctrl.samples[0].scheduleDate.isValid())
						$scope.ctrl.goToDate($scope.ctrl.samples[0].scheduleDate);

		}, function(response) {
			$scope.ctrl.loading = false;
		});
	}

	/*
	 * Carga los tags no repetidos en un arreglo
	 */
	function pushTag(tags) {
		if (!tags)
			return;
		var t = vm.availableTags.some(function(s) {
			return s == tags;
		});

		if (t)
			return;

		vm.availableTags.push(tags);
	}

	/**
	 * si el sitio cambia y esta vacio, se borra el área
	 */
	vm.onSiteChange = function(site) {
		if (vm.site.selected.length <= 0)
			vm.area = {};
		// vm.search();
		vmparent.pagination.current = 1;
		realoadFilters();
	}

	/**
	 * si el cliente cambia y esta vacio se borran los asociados
	 */
	vm.onClientChange = function(client) {
		if (vm.client.selected.length <= 0) {
			vm.site = {};
			vm.area = {};
			vm.planSampling = {};
		}
		// vm.search();
		vmparent.pagination.current = 1;
		realoadFilters();
	}

	/*
	 * Cambia el valor selecionado del área
	 */
	vm.onAreaChange = function(area) {
		// vm.search();
		vmparent.pagination.current = 1;
		realoadFilters();
	}

	/**
	 * Cambia el valor seleccionado de el estado de la muestra
	 */
	vm.onStateChange = function(state) {
		// vm.search();
		vmparent.pagination.current = 1;
		realoadFilters();
	}

	/*
	 * cambia el o los tags selecionados
	 */
	vm.onTagChange = function() {
		// vm.search();
		vmparent.pagination.current = 1;
		realoadFilters();
	}

	/*
	 * Cambia el plan de muestreo
	 */
	vm.onPlanChange = function(planSamplingSelected) {
		// vm.search();
		vmparent.pagination.current = 1;
		realoadFilters();
	}

	/*
	 * Cambia la paginacion
	 */
	vm.onPageChange = function(newPage) {
		// vm.search();
		vmparent.pagination.current = newPage;
		realoadFilters();
	}

	/*
	 * Cambia la muestra
	 */
	vm.onIdSampleChange = function(idSample) {
		vmparent.pagination.current = 1;
		realoadFilters()
		// loadSamples();
	}

	/*
	 * Si se cambia de selector entre sitio y plan de muestrep
	 */

	vm.sitePlanSelectClick = function(id) {

		var aSearch = true;
		// si no hay algo en los campos de siitio o plan de muestro no actualice
		// la busqueda
		if (!((vm.site.selected && vm.site.selected.length > 0) || (vm.planSampling.selected && vm.planSampling.selected.length > 0))) {
			aSearch = false;
		}

		vm.planSiteSelected = id;
		var io = $(".btn.btn-default.dropdown-toggle site-icon");
		if (io.length === 0) {
			io = $(".btn.btn-default.dropdown-toggle plan-sampling-icon");
		}
		var e;
		if (id === 0) {// sitio
			e = $compile("<site-icon></site-icon>")($scope);
			vm.planSampling = {};
		} else {
			e = $compile("<plan-sampling-icon></plan-sampling-icon>")($scope);
			vm.site = {};
			vm.area = {};
		}
		io.replaceWith(e);

		if (aSearch)
			realoadFilters();
		// vm.search();
	}

	/**
	 * Eventos Datepicker
	 */
	function onApplyDatePicker(ev, picker) {
		// vm.search();
		vmparent.pagination.current = 1;
		realoadFilters();
	}

	/*
	 * Opciones del datepicker
	 */
	vm.opts = {
		locale : {
			applyClass : 'btn-green',
			applyLabel : "Elegir",
			fromLabel : "desde",
			format : "YYYY-MM-DD",
			toLabel : "a",
			cancelLabel : 'Cancelar',
			customRangeLabel : 'Personalizado'
		},
		ranges : {
			'Sin fecha' : [ '', '' ],
			'Últimos 7 dias' : [ moment().subtract(6, 'days'), moment() ],
			'Últimos 30 dias' : [ moment().subtract(29, 'days'), moment() ],
			'Este mes' : [ moment().startOf('month'), moment().endOf('month') ],
			'Próximos 7 dias' : [ moment(), moment().add(6, 'days') ],
			'Próximos 30 dias' : [ moment(), moment().add(29, 'days') ],
		},
		autoApply : true,
		eventHandlers : {
			'apply.daterangepicker' : onApplyDatePicker
		},
		dateLimit : {
			month : 2
		}
	};

	init();
	// vm.search();

}